// extracted by mini-css-extract-plugin
module.exports = {"warning":"Prebook_warning__Laxuh"};